import { useSignIn as useLegacySignIn } from "@clerk/react/legacy"

/** Tipos e helpers de autenticação compartilhados pelo login e pela área do cliente. */

export type Status = "idle" | "saving" | "success" | "error"

export type LegacySignInResource = NonNullable<ReturnType<typeof useLegacySignIn>["signIn"]>
export type PasswordResetStep = "request" | "verify" | "password"

export type PasswordResetCompletePayload = {
  createdSessionId: string | null
  email: string
}


export function getAuthErrorMessage(error: unknown, fallback: string) {
  if (
    error &&
    typeof error === "object" &&
    "errors" in error &&
    Array.isArray(error.errors) &&
    error.errors[0] &&
    typeof error.errors[0] === "object" &&
    "message" in error.errors[0] &&
    typeof error.errors[0].message === "string"
  ) {
    return error.errors[0].message
  }
  if (error instanceof Error) {
    return error.message
  }
  return fallback
}

export function isExistingSessionError(error: unknown) {
  if (!error || typeof error !== "object" || !("errors" in error)) return false
  const errors = (error as { errors?: Array<{ code?: string; message?: string }> }).errors
  return Boolean(
    errors?.some((entry) => {
      const code = entry.code?.toLowerCase() ?? ""
      const message = entry.message?.toLowerCase() ?? ""
      return code.includes("session") || message.includes("session already exists")
    })
  )
}
